var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "tooltip",
    { attrs: { text: "This file is more than a week old" } },
    [
      _c(
        "span",
        {
          attrs: {
            role: "img",
            "aria-label": "File is more than a week old",
            tabindex: "0"
          }
        },
        [
          _c("i", {
            staticClass: "fa fa-exclamation-circle stale-icon",
            attrs: { "aria-hidden": "true" }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }